import { defaultRecommendations } from '@features/executive-report/domain/default-recommendations';
import { FormSchema } from './form-schema';
import { defaultObservations } from '@features/executive-report/domain/default-observations';
import { SubdimensionsByName } from '@features/reports/subdomains/cpg';
import { sanitizeFormKey } from '@utils/form-keys';

export const defaultValues = (
  campaignName: string,
  subdimensionsByName: SubdimensionsByName
): FormSchema => ({
  campaignName,
  teamMembers: [],
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  salesDimensionRecommendations: {
    who: '',
    what: '',
    where: '',
    how: '',
  },
  subdimensionImagesByNameAndValue: Object.entries(subdimensionsByName).reduce(
    (acc, [dimensionSlug, subdimensions]) => {
      acc[dimensionSlug] = subdimensions.reduce(
        (acc, subdimension) => {
          if (!acc) return acc;

          acc[sanitizeFormKey(subdimension.dimensionValue)] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue'][string]
      );
      return acc;
    },
    {} as FormSchema['subdimensionImagesByNameAndValue']
  ),
  recommendations: defaultRecommendations,
  observations: defaultObservations,
  includedSlides: {
    intro: {
      title: true,
      meetYourTeam: true,
      agenda: true,
      navigatingComplexity: true,
      incrementalityMatters: true,
    },
    sales: {
      cover: true,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      how: true,
    },
    takeaways: {
      recommendations: true,
      discoverWhatsNext: true,
    },
  },
});
